import React from 'react';
import { useHistory } from 'react-router-dom';
import {
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Grid,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from '@material-ui/core';
import { FiberManualRecord as BulletIcon } from '@material-ui/icons';

// styles
import useStyles from './styles-other-lab-works';

// components
import { Button, Chip, Typography } from '../../components/Wrappers';

const labWorks = [
    { label: 'Occlusal splints (soft, hard, or combination soft/hard)', bestSeller: true },
    { label: 'Fixed orthodontic wires (straight and hygienic)', bestSeller: true },
    { label: 'Essix retainers', bestSeller: true },
    { label: 'Essix dentures (retainer with acrylic pontic)' },
    { label: 'Sleep apnea appliances (mandibular advancement appliances)' },
    { label: 'Farrar splint' },
    { label: 'Gelb splint' },
    { label: 'Crowns and veneers (Zirconia, ultra-translucent Zirconia and eMax)' },
    { label: 'Partial dentures (Cobalt chrome, acrylic and Valplast)' },
    { label: 'Bleaching trays' },
    {
        label: 'Any other orthodontic appliances (fixed and removable expanders, spacers, Hawley retainers, twin blocks, Herbst appliances and more…)',
    },
];

const OtherLabWorks = () => {
    const classes = useStyles();
    const history = useHistory();

    return (
        <Grid container className={classes.gridRow}>
            <Grid item>
                <Card className={classes.card}>
                    <CardHeader title="Order Other Lab Works" />
                    <CardContent className={classes.cardContent}>
                        <Typography variant="body1" color="textSecondary" component="p" className={classes.intro}>
                            Smile Academy offers a wide range of lab works, including:
                        </Typography>

                        <List dense>
                            {labWorks.map((item) => (
                                <ListItem key={item.label} className={classes.listItem}>
                                    <ListItemIcon className={classes.listItemIcon}>
                                        <BulletIcon className={classes.bulletIcon} />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={
                                            <>
                                                <Typography component="span" variant="body1" color="textSecondary">
                                                    {item.label}
                                                </Typography>
                                                {item.bestSeller && (
                                                    <Chip
                                                        label="Best seller"
                                                        color="success"
                                                        size="small"
                                                        className={classes.bestSellerChip}
                                                    />
                                                )}
                                            </>
                                        }
                                    />
                                </ListItem>
                            ))}
                        </List>

                        <Typography variant="h6" color="textSecondary" component="h3" className={classes.sectionTitle}>
                            How to order
                        </Typography>
                        <Typography variant="body1" color="textSecondary" component="p" className={classes.paragraph}>
                            To order these items, connect your 3D scanner to Smile Academy and place your order
                            directly from your device.
                        </Typography>
                        <Typography variant="body1" color="textSecondary" component="p" className={classes.paragraph}>
                            Smile Academy has accounts with all major scanner brands, including Trios, Medit, iTero,
                            PrimeScan, Shining 3D and more.
                        </Typography>
                        <Typography variant="body1" color="textSecondary" component="p" className={classes.paragraph}>
                            You can find our lab in your scanner software by searching for &lsquo;Smile
                            Academy&rsquo; in Albion, or by searching for our lab using our email address{' '}
                            <a href="mailto:orders@smile-academy.com.au">orders@smile-academy.com.au</a>.
                        </Typography>

                        <div className={classes.contactBlock}>
                            <Typography variant="body1" color="textSecondary" component="p">
                                Contact our head office if you need assistance connecting your 3D scanner to our lab.
                            </Typography>
                            <Typography
                                variant="h6"
                                color="textSecondary"
                                component="p"
                                style={{ fontWeight: 'bold', paddingTop: 10 }}
                            >
                                Phone: <a href="tel:0735473970">07 3547 3970</a>
                            </Typography>
                        </div>
                    </CardContent>
                    <CardActions className={classes.cardActions}>
                        <Button
                            size="small"
                            color="secondary"
                            variant="outlined"
                            onClick={() => history.push('/app/dashboard')}
                        >
                            Return to Dashboard
                        </Button>
                    </CardActions>
                </Card>
            </Grid>
        </Grid>
    );
};

export default OtherLabWorks;
